export const AUTH_TOKEN_KEY = process.env.REACT_APP_AUTH_TOKEN_KEY



// WEBPACK FOOTER //
// ./src/redux/auth/constants.js